import { observer, useLocalObservable } from "mobx-react";
import { Form, Modal, Input, Spin, Alert, Select, DatePicker, Radio } from "antd";
import { translateKey as t } from "../../../../../../locales/translation";
import { ClientsController } from "../../../ClientsController";
import { AppStore } from "~/stores/AppStore";
import { useEffect } from "react";
import { CheckboxGroupProps } from "antd/es/checkbox";

const SaveScenarioSnapshotModal = observer(({ store, controller }: { store?: AppStore; controller?: ClientsController }) => {
  const [form] = Form.useForm();

  useEffect(() => {});
  const localStore = useLocalObservable(() => ({
    errorMessage: "",
    formIsValid: false,
    setError(message) {
      this.errorMessage = message;
    },

    updateFormValidity() {
      const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
      this.formIsValid = !hasErrors && form.isFieldsTouched(true);
    },
  }));

  const { visible, loading, spinMessage } = controller.saveScenarioSnapshotModal;

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      controller.setSaveScenarioSnapshotModal("loading", true);
      let foundDepot = controller.depots.find((dt) => dt._id === values.depotId);

      const depotObj = {
        _id: foundDepot._id,
        name: foundDepot.name,
        depotRef: foundDepot.depotRef,
      };

      await controller.saveScenarioSnapshot(values.scenarioRef, depotObj, values.selectedDate, values.type);

      handleClose();
    } catch (error) {
      localStore.setError(error.message);
    } finally {
      controller.setSaveScenarioSnapshotModal("loading", false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    localStore.setError("");
    controller.setSaveScenarioSnapshotModal(null, {
      visible: false,
      loading: false,
      clientRow: null,
      spinMessage: "",
    });
  };

  const dropdownFilterOption = (inp: string, opt: any) => opt.props.children?.toString().toLowerCase().indexOf(inp.toLowerCase()) >= 0;

  const renderForm = () => {
    return (
      <div className="flex justify-center items-center">
        <Form form={form} layout="vertical" className="w-full" onFieldsChange={localStore.updateFormValidity}>
          <Form.Item name="type" rules={[{ required: true, message: "Select Type" }]} className="text-center  mb-0">
            <div className="flex justify-center">
              <Radio.Group buttonStyle="solid">
                <Radio.Button value="route">Route</Radio.Button>
                <Radio.Button value="dispatch">Dispatch</Radio.Button>
              </Radio.Group>
            </div>
          </Form.Item>

          <Form.Item label="Scenario Ref" name="scenarioRef" rules={[{ required: true, message: "Please enter a scenario reference" }]}>
            <Input placeholder="Enter scenario reference" className="w-full" />
          </Form.Item>

          <div className="flex gap-4">
            <Form.Item label="Depot" name="depotId" rules={[{ required: true, message: "Select Depot" }]} className="flex-1">
              <Select allowClear showSearch style={{ width: "100%", textAlign: "left" }} filterOption={(input, option) => dropdownFilterOption(input, option)}>
                {controller.depots.map((depot) => (
                  <Select.Option key={depot._id} value={depot._id}>
                    {depot.depotRef + " - " + depot.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Date" name="selectedDate" rules={[{ required: true, message: "Select Date" }]} className="flex-1">
              <DatePicker style={{ width: "100%" }} />
            </Form.Item>
          </div>

          {localStore.errorMessage && <Alert message={localStore.errorMessage} type="error" showIcon />}
        </Form>
      </div>
    );
  };

  if (!visible) {
    return null;
  }

  return (
    <Modal
      title="Save Scenario Snapshot"
      styles={{
        header: { borderBottom: "1px solid #0505050f", paddingBottom: 10 },
      }}
      open={visible}
      cancelText={t("lblCancel", "Cancel")}
      okText={t("lblSave", "Save")}
      onCancel={handleClose}
      centered={true}
      okType="primary"
      onOk={handleOk}
      maskClosable={false}
      okButtonProps={{ disabled: !localStore.formIsValid }}
    >
      <Spin size="large" spinning={loading} tip={spinMessage}>
        {renderForm()}
      </Spin>
    </Modal>
  );
});

export default SaveScenarioSnapshotModal;
